import {
    ADDTOCART_POST_REQUEST,
    ADDTOCART_KEEPSHOPPING_ONCLICK,
    ITEM_UPDATE_REQUEST,
    ADDTOCART_STICKY_ONCLICK,
    ADDTOCART_ONCLICK,
} from '../actionTypes/AddToCartActionTypes';

export const addItemToCart = (payload) => ({
    type: ADDTOCART_POST_REQUEST,
    payload,
});

export const closeCartModal = (payload) => ({
    type: ADDTOCART_KEEPSHOPPING_ONCLICK,
    payload,
});

export const updateCartItem = (payload) => ({
    type: ITEM_UPDATE_REQUEST,
    payload,
});

export const addToCartStickyOnClick = () => ({
    type: ADDTOCART_STICKY_ONCLICK,
});

export const addToCartOnClick = () => ({
    type: ADDTOCART_ONCLICK,
});
